import { Context, createContext } from 'react'

import { UserPermissions } from '@arriere/types/Auth.types'

export interface UserProfile {
  name: string
  id: string
  email: string
  photo: string
  voyageId?: string
  permissions?: UserPermissions
  roles?: { id: string; name: string }[]
}

export type AuthContextType = {
  user: UserProfile | null
  isAuthorizing: boolean
  isSignedIn: boolean
  signIn: () => void
  signOut: () => void
  refreshPermissions: () => Promise<void>
}

export const initialContext: AuthContextType = {
  user: null,
  isAuthorizing: false,
  isSignedIn: false,
  signIn: () => {},
  signOut: () => {},
  refreshPermissions: () => Promise.resolve(),
}

const AuthContext: Context<AuthContextType> = createContext(initialContext)

export default AuthContext
